<template>
  <div class="TextAndImageVideoContentBlock">
    <div class="grid flex">
      <div class="col-1-1">
        <UIHeadingType
          class="mb-0 md-show hide"
          :heading-type="content.seoHeadingtype"
          :title="content.title"
        />
      </div>
      <div
        class="col-5-12 md-col-1-1 md-push-0 text-wrapper"
        :class="reverseClass === 'swapped' ? 'order-2 push-1-12' : 'order-1'"
      >
        <UIHeadingType
          class="mb-0 md-hide"
          :heading-type="content.seoHeadingtype"
          :title="content.title"
        />

        <div
          class="raw"
          v-html="content.text"
        />
        <div class="btn-container">
          <UIContentblockButton
            v-if="content.linkObject"
            class="btn btn-tertiary"
            :name="content.linkObject?.name"
            :link="content.linkObject?.link"
            :target="content.linkObject?.target"
          />
        </div>
      </div>

      <div
        class="col-6-12 md-col-1-1 md-push-0 md-mtb-xxlg imageContainer"
        :class="reverseClass === 'swapped' ? 'order-1' : 'order-2 push-1-12'"
      >
        <div class="image-inside">
          <BaseImage
            :media-object="content.imageObject"
            :sizes="{ md: 800 }"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
  import type { TextAndImageVideoContent } from '@/types/contentblocks'
  import type { ElocusPage, BreadCrumb } from '@tc8l/nuxt-base'

  const props = defineProps<{
    content: TextAndImageVideoContent
    breadCrumb?: BreadCrumb[]
    settings?: ElocusPage
    contentblockIdx?: number
  }>()

  const reverseClass = props.content.alignmentText === 'false' ? 'swapped' : ''
</script>

<style lang="scss" scoped>
  .grid {
    position: relative;
    align-items: start;
  }
  .text-wrapper {
    display: flex;
    flex-direction: column;
    gap: var(--margin-xlg);

    // .text :deep(p:last-child) {
    //   margin-bottom: 0;
    // }
  }

  .image-inside {
    position: relative;
    display: flex;
    width: 100%;
    height: 100%;
    aspect-ratio: 725 / 700;

    border-radius: var(--border-radius-lg);
    overflow: hidden;
    :deep(.ImageComponent) {
      height: 100%;

      .image-wrapper {
        height: 100%;

        img {
          position: absolute;
          height: 100%;
          object-fit: cover;
        }
      }
    }

    img {
      width: 100%;
    }
  }

  .ImageComponent,
  .image-wrapper {
    width: 100%;
  }

  :deep(.image-wrapper) {
    width: 100%;
  }

  @include media(md) {
    .image-inside {
      aspect-ratio: 724 / 640;

      :deep(.ImageComponent) {
        .image-wrapper {
          img {
            position: relative;
          }
        }
      }
    }

    .text-wrapper {
      order: 2 !important;
    }

    .imageContainer {
      order: 1 !important;
    }
  }
</style>
